import { VariaveisAmbiente } from 'config';
import { ApiListModel } from 'model/api/gestao/api-list-model/api-list-model';
import { TerminalHistoricoModel } from 'model/api/gestao/terminal/terminal-historico-model';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';

export function useGetHistoricoTerminal() {
    const { invocarApi, ...outrasPropriedades } = useApiBase<ApiListModel<TerminalHistoricoModel>>();

    const getHistoricoTerminal = useCallback(
        (terminalId: string, newPage: number, query?: string) =>
            invocarApi({
                url: `${VariaveisAmbiente.apiVersion}/Terminal/${terminalId}/historico?page=${newPage}&${query}`,
                method: 'GET',
                enviarTokenUsuario: true
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        getHistoricoTerminal,
    };
}
